import styled, { css } from "styled-components"

import Icon from "~/components/atoms/Icon"
import Tag from "~/components/atoms/Tag"
import Typography from "~/components/atoms/Typography"
import { Color, IsMobile, LineHeight, TextSize } from "~/consts/style-mixins"

interface Props {
  occupation: string
  targetGradYears: (number | null)[]
  title: string
  regions: string[]
  income: number
}

const NewGradJobHead = ({ occupation, targetGradYears, title, regions, income }: Props) => {
  const formattedGradYears = () => {
    if (targetGradYears.includes(null)) {
      return "全卒業年"
    }
    return targetGradYears.map((year) => year && String(year).slice(2) + "年卒").join(" / ")
  }

  return (
    <Container>
      <Tag color={Color.Primary} size="Large">
        {occupation}
      </Tag>
      <span className="grad-years">{formattedGradYears()}対象</span>
      <h1 className="heading">
        <Typography type="SubHero">{title}</Typography>
      </h1>
      <div className="under-container">
        <span className="regions">
          <StyledIcon type="Area" color={Color.Primary} size={16} />
          <span className="regions-wrapper">{regions.join(" / ")}</span>
        </span>
        {income && (
          <span className="income">
            <StyledIcon type="Money" color={Color.Primary} size={16} />
            {income}万円〜
          </span>
        )}
      </div>
    </Container>
  )
}

const Container = styled.div`
  .heading {
    margin: 8px 0;
  }
  .grad-years {
    margin-left: 8px;
    font-size: ${TextSize.XS}px;
    font-weight: bold;
    color: ${Color.Gray};
  }
  .under-container {
    display: flex;
  }
  .regions,
  .income {
    display: flex;
    align-items: center;
    font-size: ${TextSize.XS}px;
    line-height: ${LineHeight.XS}%;
    color: ${Color.Gray};
  }
  .regions-wrapper {
    ${IsMobile(css`
      max-width: 214px;
    `)}
  }
  .income {
    margin-left: 8px;
  }
`

const StyledIcon = styled(Icon)`
  margin-right: 4px;
`

export default NewGradJobHead
